/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query LCRRouteReadQuery($type: CUSTOMER_TYPE!, $take: PositiveInt, $skip: Int, $search: String, $filter: JSONObject) {
    LCRRouteRead(type: $type, take: $take, skip: $skip, search: $search, filter: $filter) {
      id,
      createdAt,
      updatedAt,
      displayName,
      type,
      message,
      status,
      _totalCount,
      Account {
        email
        displayName
      }
      LCRRoutePlan {
        id,
      }
    }
  }
`
